import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getFastingStatistics } from './queries/queries';
import { InfoCardWithPieChartWidget } from '../../../../statisticsWidgets/statisticsWidgets';
import DataProcessor from '../../common/dataProcessors/fastingDataProcessor';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Fasting extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.church.daily.fasting;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'day');
  }

  render() {
    return (
      <InfoCardWithPieChartWidget primaryColor="#5856d6" secondaryColor="#595959"
                                  icon="icon-food" title="Daily Fasting"
                                  data={this.dataProcessor.data} chartData={this.dataProcessor.chartData}
                                  chartColors={['#8483d2', '#f9b452']}
                                  loading={this.props.data.loading}
                                  comment={this.comment}/>
    );
  }
}

export default compose(
  graphql(getFastingStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Fasting);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/daily/fasting.js